import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { tt } from '@i18n/tt';
import Button from 'components/Button/Button';
import { useAppDispatch } from 'store/hooks';
import { setUIMode } from 'store/uiMode';
import { setStorageShowNewUIModal } from 'constants/storage';
import useSharedStyles from 'sharedStyles';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const NewUIDesignModal: React.FC<IProps> = ({ open, onClose }) => {
  const dispatch = useAppDispatch();
  const sharedStyles = useSharedStyles();

  const handleSubmit = () => {
    dispatch(setUIMode(true));
    setStorageShowNewUIModal(false);
    window.location.reload();
  };

  const handleClose = () => {
    setStorageShowNewUIModal(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h6">{tt('newUIDesignModal.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{tt('newUIDesignModal.description')}</Typography>
      </DialogContent>
      <DialogActions className={sharedStyles.dialogActions}>
        <Button text={tt('newUIDesignModal.no')} onClick={handleClose} />
        <Button text={tt('newUIDesignModal.yes')} onClick={handleSubmit} />
      </DialogActions>
    </Dialog>
  );
};

export default NewUIDesignModal;
